import './NotPublished.scss';

function NotPublished() {
  return (
    <div className="not-published">
      <div className="not-published__content">
        <h1>Website Is Not Published</h1>
        <p>This website has not been published yet. Please contact the site administrator.</p>
      </div>
    </div>
  );
}

export default NotPublished;
